<script>
    import { onDestroy, onMount } from "svelte";
    import { prePopulateAccountOptions } from "../../../stores";
    import { showError } from "../../../Utils/utilFunctions.svelte";
    import { SearchInput } from "../../../Components/Common/index.svelte";
    import { cacheAccountPrePopulateSearchOptions } from "../../../Utils/utilCache.svelte";
    import { fade, fly } from "svelte/transition";

    export let searchDoctorArr = [];
    export let allDoctors = [];
    export let isVisibleDoctorsCollapsed = false;
    export let isLoadingDoctors = false;
    export let isCalendarInit = false;
    export let handleSearchDoctorsChange = async () => {};

    let quickSearchText = "",
        filteredDoctors = [];

    onMount(async () => {
        await loadDoctors();
    });

    onDestroy(() => {
        searchDoctorArr = [];
    });

    const loadDoctors = async () => {
        await cacheAccountPrePopulateSearchOptions();

        _handleLoadDoctors({
            results: $prePopulateAccountOptions,
        });

        await toggleChange();

        isLoadingDoctors = false;
    };

    const toggleChange = async (id = Number(0)) => {
        if (
            searchDoctorArr.some((doctor) => doctor.id == id) ||
            searchDoctorArr.some((dID) => dID == id)
        )
            searchDoctorArr = searchDoctorArr.filter(
                (doctor) => doctor.id != id && doctor != id,
            );
        else
            searchDoctorArr = [
                ...searchDoctorArr,
                ...allDoctors.filter((doctor) => doctor.id == id),
            ];

        isCalendarInit && (await handleSearchDoctorsChange(searchDoctorArr));
    };

    const toggleSearchAll = async () => {
        if (searchDoctorArr.length < allDoctors.length)
            searchDoctorArr = [...allDoctors];
        else searchDoctorArr = [];

        await handleSearchDoctorsChange(searchDoctorArr);
    };

    const handleQuickSearchDoctors = () => {
        if (!quickSearchText) filteredDoctors = [...allDoctors];
        else
            filteredDoctors = allDoctors.filter(({ fullName }) =>
                fullName.toLowerCase().includes(quickSearchText.toLowerCase()),
            );
    };

    // HELPER FUNCTIONS
    const _handleLoadDoctors = (res) => {
        if (!res || res.error)
            showError(
                res.error ??
                    "Failed to load doctors, please refresh the page and try again and contact support if the issue persists.",
            );
        else {
            allDoctors = res.results;
            filteredDoctors = [...allDoctors];
            if (!searchDoctorArr.length) searchDoctorArr = allDoctors;
            else if (typeof searchDoctorArr[0] == "number")
                searchDoctorArr = allDoctors.filter((doctor) =>
                    searchDoctorArr.includes(doctor.id),
                );
        }
    };
</script>

<div
    style="visibility: {!isVisibleDoctorsCollapsed ? 'visible' : 'hidden'};"
    class="flex flex-0 flex-col overflow-hidden bg-white rounded-xl"
    out:fly={{ duration: 150, x: -50 }}
    in:fade={{ duration: 50 }}
>
    <div
        class={`sidebar flex flex-1 flex-col relative items-left gap-y-2 overflow-y-auto ${isVisibleDoctorsCollapsed ? "w-0" : "p-4 w-60"}`}
    >
        <div class="flex flex-col w-full gap-y-2">
            <div
                class="flex items-center justify-between gap-2 min-h-[42px] h-auto"
            >
                <div class="flex flex-row gap-2">
                    <input
                        id="allDoctorSearchCheckbox"
                        type="checkbox"
                        class="checkbox checkbox-secondary checkbox-xs cursor-pointer"
                        checked={searchDoctorArr.length == allDoctors.length}
                        on:change={toggleSearchAll}
                    />

                    <label
                        for="allDoctorSearchCheckbox"
                        class="cursor-pointer truncate"
                    >
                        {searchDoctorArr.length == allDoctors.length
                            ? "Uncheck all"
                            : "Check all"}
                    </label>
                </div>

                <i
                    style="font-size:16px"
                    class={`fa cursor-pointer rounded-lg ${
                        isVisibleDoctorsCollapsed ? "rotate-180" : "rotate-back"
                    }`}
                    on:click={() =>
                        (isVisibleDoctorsCollapsed =
                            !isVisibleDoctorsCollapsed)}
                >
                    &#xf104;
                </i>
            </div>

            <SearchInput
                bind:value={quickSearchText}
                placeholder="Quick search doctors"
                inputFunc={handleQuickSearchDoctors}
                inputClass="bg-zinc-100 force-w-full"
            />
        </div>

        <div class="divider"></div>

        <div class="flex flex-col items-left overflow-y-auto gap-y-4">
            {#each filteredDoctors as doctor}
                <div class="flex items-center gap-2 min-h-[42px] h-auto">
                    <input
                        id={doctor.id}
                        type="checkbox"
                        class="checkbox checkbox-secondary checkbox-xs cursor-pointer"
                        checked={searchDoctorArr.some((d) => {
                            if (typeof d == "object") return d.id == doctor.id;
                            return d == doctor.id;
                        })}
                        on:change={() => toggleChange(doctor.id)}
                    />

                    <label for={doctor.id} class="cursor-pointer truncate"
                        >{doctor.titleName} {doctor.fullName}</label
                    >
                </div>
            {/each}
        </div>
    </div>
</div>

<style>
    .sidebar {
        transition: 0.2s linear;
    }
</style>
